export default "__VITE_ASSET__Br5u1gHe__"